module.exports = __webpack_public_path__ + "img/university_9.7aaf19d3.jpg";